// src/lib/auth/resolveLoginDestination.ts
import { pickHighestAdminRole, isStaffRole, isClientRole } from '@/lib/rbac';
import { type User } from '@/types/auth';
import { CLIENT_DASHBOARD, CLINICAL_LANDING } from '@/lib/constants';

export const ADMIN_LANDING = {
  PLATFORM: '/admin/platform',
  WORKSPACE: '/admin/workspace',
} as const;

/**
 * Decide where to send a freshly-authenticated user.
 * Admin roles land on their dedicated admin surface;
 * clinical staff and support land on the clinical app;
 * clients land on the client app.
 */
export function resolveLoginDestination(user: User): string {
  const adminRole = pickHighestAdminRole(user.role);
  if (adminRole === 'super_admin') return ADMIN_LANDING.PLATFORM;
  if (adminRole === 'ba_super_admin' || adminRole === 'ba_admin') {
    return ADMIN_LANDING.WORKSPACE;
  }
  if (isStaffRole(user.role)) return CLINICAL_LANDING;
  if (isClientRole(user.role)) return CLIENT_DASHBOARD;
  return '/login';
}
